import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./login.css";
import logo from "../assets/eatnewlogo.png";
import { nutritionistLogin } from "../network/service/PlatformAuth";
import { logoutUser } from "../network/service/UserService";

/**
 * Sign-in for nutrition experts. Their accounts live on the new platform
 * (not the admin system), so they only reach the nutrition review screens.
 */
const NutritionistLogin = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const handleChanges = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const login = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await nutritionistLogin(form.email, form.password);
      // An admin session left in this browser would show the full admin menu.
      logoutUser();
      navigate("/nutrition-review");
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-page">
      <div className="row">
        <form className="login card-1" onSubmit={login}>
          <div>
            <h3 className="text-centers" style={{ color: "#fff" }}>
              <img src={logo} alt="" width="100%" />
            </h3>
            <p className="login-subtitle">Nutrition expert sign-in</p>
          </div>
          <div className="form-group">
            <label htmlFor="nutritionist-email">Email</label>
            <input
              type="email"
              name="email"
              autoComplete="username"
              value={form.email}
              onChange={handleChanges}
              id="nutritionist-email"
              className="form-control"
              placeholder="Enter email"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="nutritionist-password">Password</label>
            <input
              type="password"
              name="password"
              autoComplete="current-password"
              value={form.password}
              onChange={handleChanges}
              id="nutritionist-password"
              className="form-control"
              placeholder="Enter Password"
              required
            />
          </div>
          {error && <p className="login-error">{error}</p>}
          <button type="submit" className="btn w-100 text-center" disabled={busy}>
            {busy ? "SIGNING IN…" : "LOGIN"}
          </button>
          <Link to="/login" className="login-switch">
            Admin staff? Sign in here
          </Link>
        </form>
      </div>
    </div>
  );
};

export default NutritionistLogin;
